export const schema = {
  models: {
    Account: {
      name: 'Account',
      fields: {
        id: {
          name: 'id',
          isArray: false,
          type: 'ID',
          isRequired: true,
          attributes: [],
        },
        type: {
          name: 'type',
          isArray: false,
          type: {
            enum: 'AccountType',
          },
          isRequired: true,
          attributes: [],
        },
        name: {
          name: 'name',
          isArray: false,
          type: 'String',
          isRequired: true,
          attributes: [],
        },
        email: {
          name: 'email',
          isArray: false,
          type: 'String',
          isRequired: true,
          attributes: [],
        },
        phone: {
          name: 'phone',
          isArray: false,
          type: 'String',
          isRequired: false,
          attributes: [],
        },
        country: {
          name: 'country',
          isArray: false,
          type: 'String',
          isRequired: false,
          attributes: [],
        },
        postCode: {
          name: 'postCode',
          isArray: false,
          type: 'String',
          isRequired: false,
          attributes: [],
        },
        createdAt: {
          name: 'createdAt',
          isArray: false,
          type: 'AWSDateTime',
          isRequired: false,
          attributes: [],
          isReadOnly: true,
        },
        updatedAt: {
          name: 'updatedAt',
          isArray: false,
          type: 'AWSDateTime',
          isRequired: false,
          attributes: [],
          isReadOnly: true,
        },
      },
      syncable: true,
      pluralName: 'Accounts',
      attributes: [
        {
          type: 'model',
          properties: {},
        },
      ],
    },
    Conneqt: {
      name: 'Conneqt',
      fields: {
        id: {
          name: 'id',
          isArray: false,
          type: 'ID',
          isRequired: true,
          attributes: [],
        },
        accountId: {
          name: 'accountId',
          isArray: false,
          type: 'ID',
          isRequired: false,
          attributes: [],
        },
        accountName: {
          name: 'accountName',
          isArray: false,
          type: 'String',
          isRequired: false,
          attributes: [],
        },
        requestUserId: {
          name: 'requestUserId',
          isArray: false,
          type: 'ID',
          isRequired: false,
          attributes: [],
        },
        requestUserEmail: {
          name: 'requestUserEmail',
          isArray: false,
          type: 'String',
          isRequired: false,
          attributes: [],
        },
        requestAccountType: {
          name: 'requestAccountType',
          isArray: false,
          type: {
            enum: 'AccountType',
          },
          isRequired: false,
          attributes: [],
        },
        requestAccountEmail: {
          name: 'requestAccountEmail',
          isArray: false,
          type: 'String',
          isRequired: false,
          attributes: [],
        },
        requestPlayerId: {
          name: 'requestPlayerId',
          isArray: false,
          type: 'ID',
          isRequired: true,
          attributes: [],
        },
        requestPlayerClues: {
          name: 'requestPlayerClues',
          isArray: false,
          type: 'String',
          isRequired: true,
          attributes: [],
        },
        status: {
          name: 'status',
          isArray: false,
          type: {
            enum: 'ConneqtStatus',
          },
          isRequired: true,
          attributes: [],
        },
        responseAccountId: {
          name: 'responseAccountId',
          isArray: false,
          type: 'ID',
          isRequired: false,
          attributes: [],
        },
        responseAccountName: {
          name: 'responseAccountName',
          isArray: false,
          type: 'String',
          isRequired: false,
          attributes: [],
        },
        responseAccountType: {
          name: 'responseAccountType',
          isArray: false,
          type: {
            enum: 'AccountType',
          },
          isRequired: false,
          attributes: [],
        },
        responsePlayerId: {
          name: 'responsePlayerId',
          isArray: false,
          type: 'ID',
          isRequired: false,
          attributes: [],
        },
        responsePlayerClues: {
          name: 'responsePlayerClues',
          isArray: false,
          type: 'String',
          isRequired: false,
          attributes: [],
        },
        responseEmail: {
          name: 'responseEmail',
          isArray: false,
          type: 'String',
          isRequired: false,
          attributes: [],
        },
        approvedUserId: {
          name: 'approvedUserId',
          isArray: false,
          type: 'ID',
          isRequired: false,
          attributes: [],
        },
        approvedUserFullName: {
          name: 'approvedUserFullName',
          isArray: false,
          type: 'String',
          isRequired: false,
          attributes: [],
        },
        approvedAt: {
          name: 'approvedAt',
          isArray: false,
          type: 'AWSDateTime',
          isRequired: false,
          attributes: [],
        },
        disconnectedUserId: {
          name: 'disconnectedUserId',
          isArray: false,
          type: 'ID',
          isRequired: false,
          attributes: [],
        },
        disconnectedAccountId: {
          name: 'disconnectedAccountId',
          isArray: false,
          type: 'ID',
          isRequired: false,
          attributes: [],
        },
        disconnectedAccountName: {
          name: 'disconnectedAccountName',
          isArray: false,
          type: 'String',
          isRequired: false,
          attributes: [],
        },
        disconnectedUserFullName: {
          name: 'disconnectedUserFullName',
          isArray: false,
          type: 'String',
          isRequired: false,
          attributes: [],
        },
        disconnectedAt: {
          name: 'disconnectedAt',
          isArray: false,
          type: 'AWSDateTime',
          isRequired: false,
          attributes: [],
        },
        createdAt: {
          name: 'createdAt',
          isArray: false,
          type: 'AWSDateTime',
          isRequired: false,
          attributes: [],
          isReadOnly: true,
        },
        updatedAt: {
          name: 'updatedAt',
          isArray: false,
          type: 'AWSDateTime',
          isRequired: false,
          attributes: [],
          isReadOnly: true,
        },
      },
      syncable: true,
      pluralName: 'Conneqts',
      attributes: [
        {
          type: 'model',
          properties: {},
        },
      ],
    },
    User: {
      name: 'User',
      fields: {
        id: {
          name: 'id',
          isArray: false,
          type: 'ID',
          isRequired: true,
          attributes: [],
        },
        accountId: {
          name: 'accountId',
          isArray: false,
          type: 'ID',
          isRequired: false,
          attributes: [],
        },
        accountType: {
          name: 'accountType',
          isArray: false,
          type: {
            enum: 'AccountType',
          },
          isRequired: false,
          attributes: [],
        },
        email: {
          name: 'email',
          isArray: false,
          type: 'String',
          isRequired: true,
          attributes: [],
        },
        phone: {
          name: 'phone',
          isArray: false,
          type: 'String',
          isRequired: false,
          attributes: [],
        },
        firstName: {
          name: 'firstName',
          isArray: false,
          type: 'String',
          isRequired: true,
          attributes: [],
        },
        lastName: {
          name: 'lastName',
          isArray: false,
          type: 'String',
          isRequired: true,
          attributes: [],
        },
        postalCode: {
          name: 'postalCode',
          isArray: false,
          type: 'String',
          isRequired: false,
          attributes: [],
        },
        enabled: {
          name: 'enabled',
          isArray: false,
          type: 'Boolean',
          isRequired: true,
          attributes: [],
        },
        role: {
          name: 'role',
          isArray: true,
          type: {
            enum: 'UserRole',
          },
          isRequired: false,
          attributes: [],
          isArrayNullable: false,
        },
        createdByUserId: {
          name: 'createdByUserId',
          isArray: false,
          type: 'ID',
          isRequired: false,
          attributes: [],
        },
        inviteEmailStatus: {
          name: 'inviteEmailStatus',
          isArray: false,
          type: {
            enum: 'EmailStatus',
          },
          isRequired: false,
          attributes: [],
        },
        createdAt: {
          name: 'createdAt',
          isArray: false,
          type: 'AWSDateTime',
          isRequired: false,
          attributes: [],
          isReadOnly: true,
        },
        updatedAt: {
          name: 'updatedAt',
          isArray: false,
          type: 'AWSDateTime',
          isRequired: false,
          attributes: [],
          isReadOnly: true,
        },
      },
      syncable: true,
      pluralName: 'Users',
      attributes: [
        {
          type: 'model',
          properties: {},
        },
      ],
    },
    Player: {
      name: 'Player',
      fields: {
        id: {
          name: 'id',
          isArray: false,
          type: 'ID',
          isRequired: true,
          attributes: [],
        },
        accountId: {
          name: 'accountId',
          isArray: false,
          type: 'ID',
          isRequired: false,
          attributes: [],
        },
        createdByUserId: {
          name: 'createdByUserId',
          isArray: false,
          type: 'ID',
          isRequired: false,
          attributes: [],
        },
        firstName: {
          name: 'firstName',
          isArray: false,
          type: 'String',
          isRequired: true,
          attributes: [],
        },
        lastName: {
          name: 'lastName',
          isArray: false,
          type: 'String',
          isRequired: true,
          attributes: [],
        },
        dateOfBirth: {
          name: 'dateOfBirth',
          isArray: false,
          type: 'AWSDateTime',
          isRequired: true,
          attributes: [],
        },
        clearedToPlay: {
          name: 'clearedToPlay',
          isArray: false,
          type: 'Boolean',
          isRequired: false,
          attributes: [],
        },
        clearedToPlayUpdatedAt: {
          name: 'clearedToPlayUpdatedAt',
          isArray: false,
          type: 'AWSDateTime',
          isRequired: false,
          attributes: [],
        },
        notClearedToPlayUpdatedAt: {
          name: 'notClearedToPlayUpdatedAt',
          isArray: false,
          type: 'AWSDateTime',
          isRequired: false,
          attributes: [],
        },
        createdAt: {
          name: 'createdAt',
          isArray: false,
          type: 'AWSDateTime',
          isRequired: false,
          attributes: [],
          isReadOnly: true,
        },
        updatedAt: {
          name: 'updatedAt',
          isArray: false,
          type: 'AWSDateTime',
          isRequired: false,
          attributes: [],
          isReadOnly: true,
        },
      },
      syncable: true,
      pluralName: 'Players',
      attributes: [
        {
          type: 'model',
          properties: {},
        },
      ],
    },
    Team: {
      name: 'Team',
      fields: {
        id: {
          name: 'id',
          isArray: false,
          type: 'ID',
          isRequired: true,
          attributes: [],
        },
        accountId: {
          name: 'accountId',
          isArray: false,
          type: 'ID',
          isRequired: false,
          attributes: [],
        },
        name: {
          name: 'name',
          isArray: false,
          type: 'String',
          isRequired: true,
          attributes: [],
        },
        createdByUserId: {
          name: 'createdByUserId',
          isArray: false,
          type: 'ID',
          isRequired: false,
          attributes: [],
        },
        playerIds: {
          name: 'playerIds',
          isArray: true,
          type: 'ID',
          isRequired: false,
          attributes: [],
          isArrayNullable: true,
        },
        teamManagerUserIds: {
          name: 'teamManagerUserIds',
          isArray: true,
          type: 'ID',
          isRequired: false,
          attributes: [],
          isArrayNullable: true,
        },
        createdAt: {
          name: 'createdAt',
          isArray: false,
          type: 'AWSDateTime',
          isRequired: false,
          attributes: [],
          isReadOnly: true,
        },
        updatedAt: {
          name: 'updatedAt',
          isArray: false,
          type: 'AWSDateTime',
          isRequired: false,
          attributes: [],
          isReadOnly: true,
        },
      },
      syncable: true,
      pluralName: 'Teams',
      attributes: [
        {
          type: 'model',
          properties: {},
        },
      ],
    },
    Incident: {
      name: 'Incident',
      fields: {
        id: {
          name: 'id',
          isArray: false,
          type: 'ID',
          isRequired: true,
          attributes: [],
        },
        accountId: {
          name: 'accountId',
          isArray: false,
          type: 'ID',
          isRequired: false,
          attributes: [],
        },
        accountName: {
          name: 'accountName',
          isArray: false,
          type: 'String',
          isRequired: false,
          attributes: [],
        },
        playerId: {
          name: 'playerId',
          isArray: false,
          type: 'ID',
          isRequired: true,
          attributes: [],
        },
        playerFullName: {
          name: 'playerFullName',
          isArray: false,
          type: 'String',
          isRequired: false,
          attributes: [],
        },
        report: {
          name: 'report',
          isArray: false,
          type: 'AWSJSON',
          isRequired: true,
          attributes: [],
        },
        incidentDateTime: {
          name: 'incidentDateTime',
          isArray: false,
          type: 'AWSDateTime',
          isRequired: true,
          attributes: [],
        },
        notes: {
          name: 'notes',
          isArray: true,
          type: 'String',
          isRequired: false,
          attributes: [],
          isArrayNullable: true,
        },
        copyOfId: {
          name: 'copyOfId',
          isArray: false,
          type: 'String',
          isRequired: true,
          attributes: [],
        },
        createdByUserId: {
          name: 'createdByUserId',
          isArray: false,
          type: 'ID',
          isRequired: false,
          attributes: [],
        },
        createdByUserFullName: {
          name: 'createdByUserFullName',
          isArray: false,
          type: 'String',
          isRequired: false,
          attributes: [],
        },
        createdByAccountId: {
          name: 'createdByAccountId',
          isArray: false,
          type: 'ID',
          isRequired: false,
          attributes: [],
        },
        createdByAccountName: {
          name: 'createdByAccountName',
          isArray: false,
          type: 'String',
          isRequired: false,
          attributes: [],
        },
        originalCreatedAt: {
          name: 'originalCreatedAt',
          isArray: false,
          type: 'AWSDateTime',
          isRequired: false,
          attributes: [],
        },
        createdAt: {
          name: 'createdAt',
          isArray: false,
          type: 'AWSDateTime',
          isRequired: false,
          attributes: [],
          isReadOnly: true,
        },
        updatedAt: {
          name: 'updatedAt',
          isArray: false,
          type: 'AWSDateTime',
          isRequired: false,
          attributes: [],
          isReadOnly: true,
        },
      },
      syncable: true,
      pluralName: 'Incidents',
      attributes: [
        {
          type: 'model',
          properties: {},
        },
      ],
    },
    Assessment: {
      name: 'Assessment',
      fields: {
        id: {
          name: 'id',
          isArray: false,
          type: 'ID',
          isRequired: true,
          attributes: [],
        },
        accountId: {
          name: 'accountId',
          isArray: false,
          type: 'ID',
          isRequired: false,
          attributes: [],
        },
        accountName: {
          name: 'accountName',
          isArray: false,
          type: 'String',
          isRequired: false,
          attributes: [],
        },
        playerId: {
          name: 'playerId',
          isArray: false,
          type: 'ID',
          isRequired: true,
          attributes: [],
        },
        playerFullName: {
          name: 'playerFullName',
          isArray: false,
          type: 'String',
          isRequired: false,
          attributes: [],
        },
        assessment: {
          name: 'assessment',
          isArray: false,
          type: 'AWSJSON',
          isRequired: true,
          attributes: [],
        },
        pdfS3FileKey: {
          name: 'pdfS3FileKey',
          isArray: false,
          type: 'String',
          isRequired: false,
          attributes: [],
        },
        timeZoneOffset: {
          name: 'timeZoneOffset',
          isArray: false,
          type: 'Int',
          isRequired: false,
          attributes: [],
        },
        copyOfId: {
          name: 'copyOfId',
          isArray: false,
          type: 'ID',
          isRequired: true,
          attributes: [],
        },
        createdByUserId: {
          name: 'createdByUserId',
          isArray: false,
          type: 'ID',
          isRequired: false,
          attributes: [],
        },
        createdByUserFullName: {
          name: 'createdByUserFullName',
          isArray: false,
          type: 'String',
          isRequired: false,
          attributes: [],
        },
        createdByAccountId: {
          name: 'createdByAccountId',
          isArray: false,
          type: 'ID',
          isRequired: false,
          attributes: [],
        },
        createdByAccountName: {
          name: 'createdByAccountName',
          isArray: false,
          type: 'String',
          isRequired: false,
          attributes: [],
        },
        originalCreatedAt: {
          name: 'originalCreatedAt',
          isArray: false,
          type: 'AWSDateTime',
          isRequired: false,
          attributes: [],
        },
        createdAt: {
          name: 'createdAt',
          isArray: false,
          type: 'AWSDateTime',
          isRequired: false,
          attributes: [],
          isReadOnly: true,
        },
        updatedAt: {
          name: 'updatedAt',
          isArray: false,
          type: 'AWSDateTime',
          isRequired: false,
          attributes: [],
          isReadOnly: true,
        },
      },
      syncable: true,
      pluralName: 'Assessments',
      attributes: [
        {
          type: 'model',
          properties: {},
        },
      ],
    },
    Notification: {
      name: 'Notification',
      fields: {
        id: {
          name: 'id',
          isArray: false,
          type: 'ID',
          isRequired: true,
          attributes: [],
        },
        accountId: {
          name: 'accountId',
          isArray: false,
          type: 'ID',
          isRequired: true,
          attributes: [],
        },
        createdByUserId: {
          name: 'createdByUserId',
          isArray: false,
          type: 'ID',
          isRequired: false,
          attributes: [],
        },
        mainText: {
          name: 'mainText',
          isArray: false,
          type: 'String',
          isRequired: true,
          attributes: [],
        },
        linkType: {
          name: 'linkType',
          isArray: false,
          type: {
            enum: 'LinkType',
          },
          isRequired: true,
          attributes: [],
        },
        linkId: {
          name: 'linkId',
          isArray: false,
          type: 'String',
          isRequired: false,
          attributes: [],
        },
        read: {
          name: 'read',
          isArray: false,
          type: 'Boolean',
          isRequired: true,
          attributes: [],
        },
        createdAt: {
          name: 'createdAt',
          isArray: false,
          type: 'AWSDateTime',
          isRequired: false,
          attributes: [],
          isReadOnly: true,
        },
        updatedAt: {
          name: 'updatedAt',
          isArray: false,
          type: 'AWSDateTime',
          isRequired: false,
          attributes: [],
          isReadOnly: true,
        },
      },
      syncable: true,
      pluralName: 'Notifications',
      attributes: [
        {
          type: 'model',
          properties: {},
        },
      ],
    },
  },
  enums: {
    AccountType: {
      name: 'AccountType',
      values: ['ORGANISATION', 'GUARDIAN', 'CLINIC'],
    },
    UserRole: {
      name: 'UserRole',
      values: ['ADMIN', 'USER', 'MD', 'ALLIED_HEALTH'],
    },
    ConneqtStatus: {
      name: 'ConneqtStatus',
      values: [
        'CREATED',
        'ACCOUNT_NOT_FOUND',
        'INVITE_SENT',
        'INVITE_FAILED',
        'RESEND_INVITE',
        'PENDING',
        'CONNEQTED',
        'DISCONNEQTED',
        'CLINIC_APPOINTMENT_BOOKED',
        'CANCELLED',
        'REJECTED',
        'HARD_RESET',
      ],
    },
    LinkType: {
      name: 'LinkType',
      values: [
        'CONNEQT',
        'PLAYER',
        'INCIDENT',
        'ASSESSMENT',
        'CLEARED',
        'ROLE_UPDATE',
        'NONE',
      ],
    },
    EmailStatus: {
      name: 'EmailStatus',
      values: ['BOUNCED', 'COMPLAINT', 'DELIVERED'],
    },
  },
  nonModels: {},
  codegenVersion: '3.4.0',
  version: 'c651e7784fe30289e8e737f2a8dab351',
};
